import { Stack } from "@chakra-ui/react";
import CDS from "design-system";
import EmbeddedHtml from "components/DataDisplay/EmbeddedHtml";
import { Heading22 } from "components/Heading";

import { DEFAULT_RESPONSE_SCREEN_HEADER, DEFAULT_RESPONSE_SCREEN_TEXT } from "../constants";

interface Props {
  header?: string | null;
  text?: string | null;
  onGoHome: () => void;
}

// Shared by the real form-response page and the builder's preview so they can't drift.
export default function FormSubmittedView({ header = null, text = null, onGoHome }: Props) {
  return (
    <Stack spacing={5} align="center" py={6}>
      <Heading22 as="h1" fontSize="24px" fontWeight={700} textAlign="center">
        {header || DEFAULT_RESPONSE_SCREEN_HEADER}
      </Heading22>
      <EmbeddedHtml
        innerHtml={text || DEFAULT_RESPONSE_SCREEN_TEXT}
        color="fg.subtle"
        textAlign="center"
      />
      <CDS.Button intent={CDS.Button.intent.indigo} variant={CDS.Button.variant.solid} onClick={onGoHome}>
        Go home
      </CDS.Button>
    </Stack>
  );
}
